import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MigrationEntity, Conflict, IConflict } from './conflict';

export const MOCK_CONFLICT_RESPONSE: IConflict[] = [
	{
		conflictId: 'CONFLICT_ID_0',
		migrationId: 'MIGRATION_ID',
		conflictEntityType: 'CONTACT' as MigrationEntity,
		conflictStatus: 'unresolved',
		conflictResolution: undefined,
		sourceEntityId: '12345678',
		sourceEntityName: 'Jim John',
		conflictCreatedDate: '1-1-2021',
		conflictChangeDate: '1-1-2021',
		sourceEntityData: {
			name: 'Jim John',
			email: 'jimmy@gmail.com',
			nid: '460-92-1092'
		},
		matches: [
			{
				selected: false,
				data: {
					name: 'Jimmy John',
					email: 'jimmy@gmail.com',
					nid: '460-92-1092'
				}
			}, {
				selected: false,
				data: {
					name: 'Jim John',
					email: 'jimmyjohn@gmail.com',
					nid: '460-92-5555'
				}
			}
		]
	}, {
		conflictId: 'CONFLICT_ID_1',
		migrationId: 'MIGRATION_ID',
		conflictEntityType: 'OFFICE' as MigrationEntity,
		conflictStatus: 'unresolved',
		conflictResolution: undefined,
		sourceEntityId: '87654321',
		sourceEntityName: 'Ann Arbor, Michigan',
		conflictCreatedDate: '1-1-2021',
		conflictChangeDate: '1-1-2021',
		sourceEntityData: {
			name: 'Ann Arbor, Michigan',
			code: 'AA'
		},
		matches: [
			{
				selected: false,
				data: {
					name: 'Ann Arbor, Michigan',
					code: 'A2'
				}
			}
		]
	}
];

export interface IMigrationConflictService {
	update(conflict: Conflict);
	get(migrationId: string, conflictId: string): Observable<Conflict>;
	getList(migrationId: string, conflictStatus?: string/*, conflictEntityType?: string*/): Observable<Conflict[]>;
}

const MIGRATION_ORCHESTRATOR_API = '/api/migration-orchestrator';
const GET_CONFLICTS =
	(migrationId: string) => `${MIGRATION_ORCHESTRATOR_API}/v1/migrations/${migrationId}/conflicts`;
const GET_CONFLICT =
	(migrationId: string, conflictId: string) => `${GET_CONFLICTS(migrationId)}/${conflictId}`;
const PUT_CONFLICT = GET_CONFLICT;

@Injectable({
	providedIn: 'root'
})
export class MigrationConflictsService implements IMigrationConflictService {
	constructor(private http: HttpClient) { }

	update(conflict: Conflict) {
		return this.http.put(PUT_CONFLICT(conflict.migrationId, conflict.conflictId), conflict.serialize());
	}

	get(migrationId: string, conflictId: string): Observable<Conflict> {
		return this.http.get<IConflict>(GET_CONFLICT(migrationId, conflictId)).pipe(
			map(conflict => new Conflict(conflict)));
	}

	getList(migrationId: string, conflictStatus?: string/*, conflictEntityType?: string*/): Observable<Conflict[]> {
		return this.http.get<IConflict[]>(GET_CONFLICTS(migrationId), {
			params: {
				conflictStatus,
				// conflictEntityType
			}
		}).pipe(
			map(conflicts => conflicts?.map(conflict => new Conflict(conflict))));
	}
}
